<epay-page-content [pagetitle]="pagetitle">
  <div class="box-panel shadow max-w max-gs">
    <div class="m--pa4">
      <h2 class="mb-5">Contact Us</h2>
      <h3>Address</h3>
      Tennessee State Disbursement Unit <br>
      P.O. Box 305200 <br>
      Nashville, TN 37229 <br>
      <br>
      <h3>Telephone</h3>
      (833) 772-TDHS (8347)
      <div style="font-size: smaller;"><i>Note: If you are calling from a cell phone and have free long distance, 
        please call the local number instead of the toll free number.</i></div>
      <br>
      <h3>E-mail</h3>
      <address>
        <a href="mailto:tnccu@smimail.net">
          <u>tnccu@smimail.net</u>
        </a>
      </address>
      <div style="font-size: smaller;"><i>Note: Please include the following in your e-mail: employer’s name, your name,
          and a number where we can reach you.</i>
      </div>
      <br>

      <div *ngIf="this.chatLive">
        <h3>Live Chat</h3>
        <span>
          <img (click)="openChat()" src="../../../../../assets/images/chaticonmid.png" style="cursor: pointer">
        </span>
      </div>

    </div>
  </div>
</epay-page-content>
